import {PageFragment, PageFragmentProps, PageFragmentStyleFlags} from "@/shared/PageFragment";
import React from "react";
import {StyledContainer, StyledWidget} from "@/shared/StyledComponents";
import {Grid} from "@mui/material";
import {PD_SM} from "@/shared/dimens";
import {Action, ACTION_SPACE, WidgetItem} from "@/shared/types";
import {
  AttachMoneyOutlined,
  BarChartOutlined,
  BuildOutlined, MonetizationOnOutlined,
  Person3Outlined,
  ScheduleOutlined,
  SettingsOutlined
} from "@mui/icons-material";
import {
  ActivePatientsWidget,
  AppointmentsWidget,
  DailyAppointmentsWidget,
  DailyRevenueWidget,
  RevenueWidget
} from "./HomeWidgets";

export type HomeFragmentProps = PageFragmentProps & {
  children?: any,
}

const HEAD_ITEMS: WidgetItem[] = [
  {
    title: "Revenue",
    iconType: AttachMoneyOutlined,
    render: pathProps => <RevenueWidget path={pathProps}/>,
  },
  {
    title: "Appointments",
    iconType: ScheduleOutlined,
    render: pathProps => <AppointmentsWidget path={pathProps}/>,
  },
  {
    title: "Active Patients",
    iconType: Person3Outlined,
    render: pathProps => <ActivePatientsWidget path={pathProps}/>,
  },
];

const MAIN_ITEMS: WidgetItem[] = [
  {
    title: "Daily Revenue",
    iconType: BarChartOutlined,
    render: pathProps => <DailyRevenueWidget path={pathProps} type={"line"}/>,
  },
  {
    title: "Daily Appointments",
    iconType: BarChartOutlined,
    render: pathProps => <DailyAppointmentsWidget path={pathProps} type={"line"}/>,
  },
];

export class HomeFragment extends PageFragment<HomeFragmentProps> {

  protected styleFlags(): number | PageFragmentStyleFlags {
    return PageFragment.STYLE_TOOLBAR_TYPE_FLAG;
  }

  protected getTitle(): string | null | undefined {
    return "Dashboard";
  }

  protected getToolbar(toolbarModeId: string | null): React.ReactElement {
    return this.renderToolbarButtonsInToolbarContainerEx([
      ACTION_SPACE,
      new Action("Customize", () => {
      }, SettingsOutlined),
    ]);
  }

  renderContent(): React.ReactElement {
    return <StyledContainer style={{padding: PD_SM, position: "relative"}}>
      <Grid container spacing={2}>
        {HEAD_ITEMS.map(item => this.renderHeadItem(item))}
      </Grid>
      <Grid container spacing={2}>
        {MAIN_ITEMS.map(item => this.renderMainItem(item))}
      </Grid>
    </StyledContainer>;
  }

  private renderHeadItem(item: WidgetItem) {
    return <Grid item xs={12} sm={6} md={4}>
      <StyledWidget size={"xsm"} path={this.props.path} item={item}/>
    </Grid>;
  }

  private renderMainItem(item: WidgetItem) {
    return <Grid item sm={12} md={6}>
      <StyledWidget path={this.props.path} item={item}/>
    </Grid>;
  }
}